
import router from './router/index'
import store from './store'
import {getCookies} from '@/utils/cookies'
router.beforeEach((to, from, next) => {
  if (getCookies('drawerStatus')) {
    let drawerStatus = (getCookies('drawerStatus') === 'true')
    store.dispatch('SetnavigationDrawer', drawerStatus)
  }
  store.dispatch('SetLoader', {status: true, message: 'Loading...'})
  let authToken = localStorage.getItem('authToken')
  if (authToken === undefined || authToken === null) {
    if (to.path !== '/' && to.path !== '/login' && to.path !== '/networkDetails') {
      next({
        path: '/login',
        query: {redirect: to.fullPath}
      })
    } else {
      next()
    }
  } else {
    if (store.getters.dateTimeFormat === '' || store.getters.dateTimeFormat === undefined) {
      store.dispatch('SetDateTimeFormat')
    }
    if (store.getters.permission.length === 0) {
      store.dispatch('GetEmployeePermission', false)
    }
    if (to.path !== '/login' && to.path !== '/') {
      next()
    } else {
      next({
        path: '/dashboard',
        query: {redirect: to.fullPath}
      })
    }
    // if (isDeviceAvailable === 'noDeviceFound') {
    //   if (to.path !== '/registerDevice') {
    //     next({
    //       path: '/registerDevice',
    //       query: {redirect: to.fullPath}
    //     })
    //   } else {
    //     next()
    //   }
    // } else {
    // if (to.path === '/companyList' && from.path !== '/login') {
    //   next({
    //     path: '/dashboard',
    //     query: {redirect: to.fullPath}
    //   })
    // }
    // }
  }
})

router.afterEach(() => {
  setInterval(() => {
    store.dispatch('SetLoader', {status: false, message: ''})
  }, 4000)
})



// WEBPACK FOOTER //
// ./src/permissions.js